import { render, staticRenderFns } from "./Codepen.vue?vue&type=template&id=27aac328&"
import script from "./Codepen.vue?vue&type=script&lang=js&"
export * from "./Codepen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports